import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

export default function useSimulateThrottleCSVForm() {
  return useForm({
    defaultValues: {
      ...defaultValues,
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });
}

const defaultValues = {
  templateId: -1,
  force_choose: '-1',
  isMultiMode: false,
  file: null,
  targetDate: null,
};

const schema = yup.object().shape({
  templateId: yup
    .number()
    .label('Email template')
    .when('isMultiMode', {
      is: false,
      then: yup
        .number()
        .min(1, 'Email template is required')
        .required(),
      otherwise: yup.number(),
    }),
  file: yup.mixed().required(),
  targetDate: yup
    .date()
    .nullable()
    .test(
      'is-more-than-a-minute',
      'Target date must be at least 5 minutes ahead.',
      value => {
        return !value || moment(value).isAfter(moment().add(5, 'minutes'));
      },
    ),
});
